module.exports = __webpack_public_path__ + "static/media/icon_right_arrow_in_circle.bb63888e.svg";